// Copyright © 2021 Move Closer

import { Component, Vue } from 'vue-property-decorator'
import { ComponentOptions } from 'vue'

import { AnyModule } from '../_contracts'

import { AbstractModuleUi } from './abstract-module.ui'

/**
 * The abstract class that every simple module's UI **HAS TO** extend.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({
  inheritAttrs: false
})
export class AbstractSimpleModuleUi<M extends AnyModule> extends AbstractModuleUi<M> {
  /**
   * @returns The Vue component that will be used to display the module's content.
   */
  public get component (): Pick<ComponentOptions<Vue>, 'template'> {
    return { template: this.html }
  }

  /**
   * @returns The `module` @Prop converted to the raw HTML.
   */
  private get html (): string {
    let html: string
    try {
      html = this.DeMarked.convertObjectsToHTML([this.module])
      this.onReady()
      return html
    } catch (e) {
      this.onError(e)
      return ''
    }
  }
}

/**
 * `ComponentOptions` that every simple module **HAS TO** extend.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const abstractSimpleModuleUiOptions: Pick<ComponentOptions<Vue>, 'template'> = {
  template: '<component :is="component" />'
}
